import React from 'react';
import apiClient, { getAccessToken } from '../../apiClient';
import './ItemForm.scss';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"; 
import { CSVLink } from "react-csv";
import { withRouter } from 'react-router-dom';
import AddBoxIcon from "@material-ui/icons/AddBox"; 
import Dialog  from "@material-ui/core/Dialog"; 
import DialogActions from "@material-ui/core/DialogActions"; 
import DialogContent from "@material-ui/core/DialogContent"; 
import DialogContentText from "@material-ui/core/DialogContentText"; 
import DialogTitle from "@material-ui/core/DialogTitle";
import TableContainer from '@material-ui/core/TableContainer';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AppBar, Tab, Tabs, Typography, Box,TextField,Button, Table,
	TableBody, TableCell, TableHead, TableRow, Grid, TablePagination, Chip, Checkbox, TableSortLabel, Divider, CircularProgress } from "@material-ui/core";
  import { makeStyles } from "@material-ui/core/styles"; 

import TargetPrice from '../TargetPrice/TargetPrice';
import { publishNotification } from '../Notification/notificationService';
import { validateItemNumericRows } from '../formValidation';

const BARCODE_LABELS_PER_SHEET = 30;

function normalizePurchaseDateForInput(raw) {
  if (raw == null || raw === '') return '';
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const m = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (m) {
    return `${m[3]}-${m[1].padStart(2, '0')}-${m[2].padStart(2, '0')}`;
  }
  return '';
}

function formatPurchaseDateDisplay(raw) {
  const iso = normalizePurchaseDateForInput(raw);
  return iso || '—';
}

function isItemActiveValue(raw) {
  const normalized = String(raw == null ? 1 : raw).toLowerCase();
  return normalized === '1' || normalized === 'true';
}

function getNewItemRowMandatoryErrors(row) {
  const missing = [];
  if (!row.categoryId || row.categoryId === 0) {
    missing.push('Category');
  }
  if (!row.itemname || String(row.itemname).trim() === '') {
    missing.push('Item Name');
  }
  return missing;
}

function validateAllNewItemRows(rows) {
  if (!rows || rows.length === 0) {
    return 'Please add at least one item before submitting.';
  }
  const rowErrors = [];
  for (let i = 0; i < rows.length; i++) {
    const missing = getNewItemRowMandatoryErrors(rows[i]);
    if (missing.length) {
      rowErrors.push(`Row ${i + 1}: ${missing.join(', ')}`);
    }
  }
  if (!rowErrors.length) return null;
  return `Please complete required fields before submitting:\n${rowErrors.join('\n')}`;
}

function validateRowsLightsRules(rows) {
  for (let i = 0; i < (rows || []).length; i += 1) {
    const raw = rows[i].lights;
    if (raw === '' || raw === null || raw === undefined) continue;
    const lights = Number(raw);
    if (!Number.isFinite(lights) || lights < 0) {
      return `Lights must be a number greater than or equal to zero for row ${i + 1}.`;
    }
  }
  return null;
}

function getDefaultLocationFromList(locationList) {
  const list = locationList || [];
  const hit = list.find(
    (x) =>
      x &&
      (x.IsDefault === 1 ||
        x.IsDefault === true ||
        String(x.IsDefault).toLowerCase() === 'true')
  );
  if (hit) return hit;
  return list.length ? list[0] : null;
}

function buildInferredLocationStockForItem(item, locationList) {
  const defaultLoc = getDefaultLocationFromList(locationList);
  if (!defaultLoc || defaultLoc.ItemLocationId == null) return [];
  const qtyRaw = item?.Quantity != null ? item.Quantity : item?.quantity;
  const qty = qtyRaw != null && qtyRaw !== '' ? Number(qtyRaw) : 0;
  return [
    {
      LocationId: defaultLoc.ItemLocationId,
      LocationName: defaultLoc.LocationName || '',
      Quantity: Number.isFinite(qty) ? qty : 0,
    },
  ];
}

function getItemLocationDisplayName(item, locationList) {
  const name =
    item?.LocationName != null
      ? String(item.LocationName).trim()
      : item?.locationName != null
        ? String(item.locationName).trim()
        : '';
  if (name) return name;
  const defaultLoc = getDefaultLocationFromList(locationList);
  return defaultLoc && defaultLoc.LocationName ? String(defaultLoc.LocationName).trim() : '';
}

function resolveEditLocationId(item, locationList) {
  if (!item) return '';
  const name = item.LocationName != null ? String(item.LocationName).trim() : '';
  if (!name || !locationList || !locationList.length) return '';
  const firstName = name.split(',')[0].trim();
  const hit = locationList.find(
    (l) =>
      String(l.LocationName || '')
        .trim()
        .toLowerCase() === firstName.toLowerCase()
  );
  return hit && hit.ItemLocationId != null ? Number(hit.ItemLocationId) : '';
}

function mergeMetricUidRows(locationStock, metricUidRows, itemFallback, locationList) {
  const byLoc = new Map();
  const qtyByLoc = new Map();
  (locationStock || []).forEach((r) => {
    const lid = Number(r.LocationId != null ? r.LocationId : r.locationId);
    if (!lid || Number.isNaN(lid)) return;
    const q = r.Quantity != null ? r.Quantity : r.quantity;
    qtyByLoc.set(lid, Number(q) || 0);
  });
  const resolveLocName = (locationId, fallbackName) => {
    const name = fallbackName != null ? String(fallbackName).trim() : '';
    if (name) return name;
    const hit = (locationList || []).find(
      (l) => Number(l.ItemLocationId) === Number(locationId)
    );
    return hit ? hit.LocationName || '' : '';
  };
  (metricUidRows || []).forEach((r) => {
    const lid = Number(r.LocationId != null ? r.LocationId : r.locationId);
    if (!lid || Number.isNaN(lid)) return;
    byLoc.set(lid, {
      locationId: lid,
      locationName: resolveLocName(lid, r.LocationName || r.locationName),
      metricUID: String(r.MetricUID ?? r.metricUID ?? '').trim(),
      quantity: qtyByLoc.has(lid) ? qtyByLoc.get(lid) : null,
    });
  });
  (locationStock || []).forEach((r) => {
    const lid = readLocationRowId(r);
    if (!lid) return;
    if (!byLoc.has(lid)) {
      byLoc.set(lid, {
        locationId: lid,
        locationName: resolveLocName(lid, r.LocationName),
        metricUID: '',
        quantity: qtyByLoc.get(lid),
      });
    } else {
      const existing = byLoc.get(lid);
      existing.locationName = resolveLocName(lid, existing.locationName || r.LocationName);
      if (existing.quantity == null) {
        existing.quantity = qtyByLoc.get(lid);
      }
    }
  });
  if (byLoc.size === 0 && itemFallback) {
    const lid = resolveEditLocationId(itemFallback, locationList);
    const numLid =
      lid === '' || lid == null || Number.isNaN(Number(lid)) ? '' : Number(lid);
    const name = resolveLocName(
      numLid,
      itemFallback.LocationName != null ? itemFallback.LocationName : itemFallback.locationName
    );
    const uid = String(
      itemFallback.MetricUID ?? itemFallback.metricUID ?? ''
    ).trim();
    if (numLid !== '' || name || uid) {
      byLoc.set(numLid || 0, {
        locationId: numLid,
        locationName: name || '—',
        metricUID: uid,
        quantity:
          itemFallback.Quantity != null && itemFallback.Quantity !== ''
            ? Number(itemFallback.Quantity)
            : null,
      });
    }
  }
  return Array.from(byLoc.values())
    .map((row) => ({
      ...row,
      quantity:
        row.quantity != null && !Number.isNaN(row.quantity)
          ? row.quantity
          : qtyByLoc.has(Number(row.locationId))
            ? qtyByLoc.get(Number(row.locationId))
            : null,
    }))
    .sort((a, b) => String(a.locationName).localeCompare(String(b.locationName)));
}

function normalizeApiListResponse(data) {
  if (data == null) return [];
  if (typeof data === 'string') {
    const trimmed = data.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return Array.isArray(data) ? data : [];
}

function readLocationRowId(row) {
  const raw = row.LocationId != null ? row.LocationId : row.locationId;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function readLocationStockQuantity(row) {
  const raw =
    row.Quantity != null
      ? row.Quantity
      : row.quantity != null
        ? row.quantity
        : null;
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

function formatQuantityDisplay(qty) {
  const n = Number(qty ?? 0);
  return (n === 0 ? 0 : n).toFixed(2);
}

function formatLocationQuantityDisplay(qty) {
  if (qty == null || Number.isNaN(Number(qty))) return '—';
  return formatQuantityDisplay(qty);
}

function buildEditLocationQuantityRows(locationStock, item, locationList, metricRows) {
  const byKey = new Map();

  const resolveLocName = (lid, fallbackName) => {
    const name = fallbackName != null ? String(fallbackName).trim() : '';
    if (name) return name;
    const hit = (locationList || []).find((l) => Number(l.ItemLocationId) === lid);
    return hit ? hit.LocationName || '—' : '—';
  };

  const upsertRow = (lid, name, qty) => {
    const trimmedName = name != null ? String(name).trim() : '';
    const key =
      lid != null && lid !== '' && Number(lid) > 0
        ? `id:${lid}`
        : trimmedName
          ? `name:${trimmedName.toLowerCase()}`
          : '';
    if (!key) return;
    const existing = byKey.get(key);
    const nextQty =
      qty != null && Number.isFinite(Number(qty))
        ? Number(qty)
        : existing && existing.quantity != null
          ? existing.quantity
          : null;
    byKey.set(key, {
      locationId: lid != null && lid !== '' ? lid : existing?.locationId || '',
      locationName: trimmedName || existing?.locationName || '—',
      quantity: nextQty,
    });
  };

  normalizeApiListResponse(locationStock).forEach((r) => {
    const lid = readLocationRowId(r);
    if (!lid) return;
    upsertRow(
      lid,
      resolveLocName(lid, r.LocationName != null ? r.LocationName : r.locationName),
      readLocationStockQuantity(r)
    );
  });

  (metricRows || []).forEach((r) => {
    const lid = readLocationRowId(r);
    const name = r.locationName != null ? r.locationName : r.LocationName;
    if (!lid && !name) return;
    upsertRow(lid, name, readLocationStockQuantity(r) ?? r.quantity);
  });

  if (byKey.size > 0) {
    return Array.from(byKey.values()).sort((a, b) =>
      String(a.locationName).localeCompare(String(b.locationName))
    );
  }

  const inferred = buildInferredLocationStockForItem(item, locationList);
  if (inferred.length) {
    return inferred.map((r) => ({
      locationId: r.LocationId,
      locationName: r.LocationName || '—',
      quantity: readLocationStockQuantity(r),
    }));
  }

  if (!item) return [];
  const names = splitCsvField(item.LocationName ?? item.locationName);
  if (!names.length) return [];
  const totalQty =
    item.Quantity != null && item.Quantity !== '' ? Number(item.Quantity) : null;
  if (names.length === 1) {
    return [
      {
        locationId: resolveEditLocationId(item, locationList),
        locationName: names[0],
        quantity: Number.isFinite(totalQty) ? totalQty : 0,
      },
    ];
  }
  return names.map((name) => ({
    locationId: resolveLocIdFromName(name, locationList),
    locationName: name,
    quantity: Number.isFinite(totalQty) ? totalQty : null,
  }));
}

/** Apply comma-separated list MetricUID values to per-location rows when a row has no UID yet. */
function enrichLocationRowsWithMetricUids(rows, item) {
  if (!rows || !rows.length) return rows || [];
  const locNames = splitCsvField(item?.LocationName ?? item?.locationName);
  const uids = splitCsvField(item?.MetricUID ?? item?.metricUID);
  return rows.map((row, idx) => {
    const existing = String(row.metricUID ?? '').trim();
    if (existing) return row;
    const rowName = String(row.locationName || '').trim().toLowerCase();
    let metricUID = '';
    const nameIdx = locNames.findIndex(
      (n) => String(n).trim().toLowerCase() === rowName
    );
    if (nameIdx >= 0 && uids[nameIdx]) {
      metricUID = uids[nameIdx];
    } else if (uids.length === rows.length && uids[idx]) {
      metricUID = uids[idx];
    } else if (uids.length === 1) {
      metricUID = uids[0];
    }
    return metricUID ? { ...row, metricUID } : row;
  });
}

/** Single edit-dialog row set: location, qty, and metric UID per location. */
function buildEditLocationDetailRows(
  mergedRows,
  locationStock,
  item,
  locationList,
  fallbackMetricUid
) {
  if (mergedRows && mergedRows.length) {
    return enrichLocationRowsWithMetricUids(mergedRows, {
      ...item,
      MetricUID: item?.MetricUID ?? item?.metricUID ?? fallbackMetricUid,
    });
  }
  const uid = String(fallbackMetricUid ?? '').trim();
  const qtyRows = buildEditLocationQuantityRows(
    locationStock,
    item,
    locationList,
    []
  );
  if (qtyRows.length) {
    return qtyRows.map((r) => ({
      locationId: r.locationId,
      locationName: r.locationName,
      quantity: r.quantity,
      metricUID: uid,
    }));
  }
  const locName = getItemLocationDisplayName(item, locationList);
  if (locName || uid) {
    return [
      {
        locationId: resolveEditLocationId(item, locationList) || '',
        locationName: locName || '—',
        quantity:
          item?.Quantity != null && item?.Quantity !== ''
            ? Number(item.Quantity)
            : null,
        metricUID: uid,
      },
    ];
  }
  return [];
}

function splitCsvField(raw) {
  if (raw == null || raw === '') return [];
  return String(raw)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

function resolveLocIdFromName(name, locationList) {
  const trimmed = name != null ? String(name).trim() : '';
  if (!trimmed || !locationList || !locationList.length) return '';
  const hit = locationList.find(
    (l) =>
      String(l.LocationName || '')
        .trim()
        .toLowerCase() === trimmed.toLowerCase()
  );
  return hit && hit.ItemLocationId != null ? Number(hit.ItemLocationId) : '';
}

function expandLocationMetricPairs(locNames, uids, qtyFallback, locationList) {
  const count = Math.max(locNames.length, uids.length);
  if (count <= 1) return null;
  return Array.from({ length: count }, (_, i) => ({
    locationId: resolveLocIdFromName(locNames[i] || locNames[0] || '', locationList),
    locationName: locNames[i] || locNames[0] || '—',
    metricUID: uids[i] || uids[0] || '',
    quantity: null,
  }));
}

function resolveBarcodeLocationRows(mergedRows, item, locationList) {
  let rows = Array.isArray(mergedRows) ? mergedRows.filter(Boolean) : [];

  if (rows.length <= 1) {
    const itemLocNames = splitCsvField(item?.LocationName ?? item?.locationName);
    const itemUids = splitCsvField(item?.MetricUID ?? item?.metricUID);
    const qtyFallback = rows[0]?.quantity ?? item?.Quantity;
    const fromItem = expandLocationMetricPairs(
      itemLocNames,
      itemUids,
      qtyFallback,
      locationList
    );
    if (fromItem && fromItem.length > 1) {
      rows = fromItem;
    } else if (rows.length === 1) {
      const fromRow = expandLocationMetricPairs(
        splitCsvField(rows[0].locationName),
        splitCsvField(rows[0].metricUID),
        rows[0].quantity,
        locationList
      );
      if (fromRow && fromRow.length > 1) rows = fromRow;
    }
  }

  if (!rows.length && item) {
    rows = [
      {
        locationId: resolveEditLocationId(item, locationList),
        locationName:
          item.LocationName != null ? String(item.LocationName).trim() : '—',
        metricUID: String(item?.MetricUID ?? item?.metricUID ?? '').trim(),
        quantity: item?.Quantity,
      },
    ];
  }

  return rows;
}

function defaultBarcodePrintCount(stockQty, itemQtyFallback, allowItemFallback = true) {
  if (stockQty != null && stockQty !== '') {
    const fromStock = Number(stockQty);
    if (Number.isFinite(fromStock)) {
      if (fromStock <= 0) return 0;
      return Math.max(1, Math.floor(fromStock));
    }
  }
  if (!allowItemFallback) return 0;
  const fromItem = parseFloat(itemQtyFallback);
  if (Number.isFinite(fromItem) && fromItem > 0) {
    return Math.max(1, Math.floor(fromItem));
  }
  return 1;
}

function buildBarcodeMetricRows(mergedRows, item, locationList) {
  const source = resolveBarcodeLocationRows(mergedRows, item, locationList);
  const allowItemFallback = source.length <= 1;
  return source.map((r) => ({
    locationId: r.locationId,
    locationName: r.locationName || '—',
    metricUID: r.metricUID || '',
    printCount: defaultBarcodePrintCount(
      r.quantity,
      item?.Quantity,
      allowItemFallback
    ),
  }));
}

function validateRowsDynamicCostRules(rows) {
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    if (!r.dynamicCost) continue;
    const tpStr = r.targetPrice;
    if (tpStr === '' || tpStr === undefined || tpStr === null) {
      return `Row ${i + 1}: Target price is required when Dynamic Cost is checked.`;
    }
    const tp = parseFloat(tpStr);
    if (Number.isNaN(tp) || tp < 0) {
      return `Row ${i + 1}: Enter a valid target price.`;
    }
    const m = parseFloat(r.margin);
    if (Number.isNaN(m) || m < 0) {
      return `Row ${i + 1}: Enter a valid margin (≥ 0).`;
    }
    if (tp - m < 0) {
      return `Row ${i + 1}: Target price must be greater than or equal to margin.`;
    }
  }
  return null;
}

function createEmptyItemRow(existingRows) {
  return {
    id: existingRows.length + 1,
    itemid: '',
    categoryId: 0,
    itemname: '',
    lights: '',
    quantity: 0,
    priperunit: 0,
    totpri: 0,
    itemnumber: '',
    cost: '',
    margin: 0,
    targetPrice: '',
    dynamicCost: false,
    isNonInventory: false,
    archived: false,
    orignalName: '',
    purchaseDate: '',
  };
}

const Panel = (props) => (
  <div hidden={props.value !== props.index}>
    <Typography>{props.children}</Typography>
  </div>
);




 class ItemForm extends React.Component {

  csvExportLinkRef = React.createRef();

        setShowBarCode= (state) => {
          if (!state) {
            this.setState({
              showBarCode: false,
              barcodeMetricUIDRows: [],
              barcodeSrc: '',
            });
            return;
          }
          this.setState({ showBarCode: state });
        };

  setShowEdit = (open) => {
    if (!open) {
      this.setState({
        showEdit: false,
        editSourceItem: null,
        editForm: null,
        editSaving: false,
        editDialogErrorMessage: null,
        editLocationStock: [],
        editLocationStockLoading: false,
        editMetricUIDRows: [],
        editMetricUIDRowsOriginal: [],
      });
    }
  };

  fetchEditLocationContext = (item) => {
    const itemId = item && (item.ItemId != null ? item.ItemId : item.itemId);
    if (!itemId) {
      this.setState({
        editLocationStock: [],
        editLocationStockLoading: false,
        editMetricUIDRows: [],
        editMetricUIDRowsOriginal: [],
      });
      return;
    }
    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user && user.accessToken ? user.accessToken : '';
    const headers = { Authorization: `Bearer ${accessToken}` };
    this.setState({ editLocationStockLoading: true });
    Promise.allSettled([
      apiClient.get(`/api/get/itemlocationstock`, { params: { itemId }, headers }),
      apiClient.get(`/api/get/itemmetricuid`, { params: { itemId }, headers }),
    ])
      .then(([stockResult, metricResult]) => {
        let stock = [];
        if (stockResult.status === 'fulfilled') {
          stock = normalizeApiListResponse(stockResult.value.data);
        }
        if (!stock.length) {
          stock = buildInferredLocationStockForItem(item, this.state.locationList);
        }
        const metricList =
          metricResult.status === 'fulfilled'
            ? normalizeApiListResponse(metricResult.value.data)
            : [];
        const merged = mergeMetricUidRows(
          stock,
          metricList,
          item,
          this.state.locationList
        );
        const locationDisplay = getItemLocationDisplayName(
          {
            ...item,
            LocationName:
              stock.length > 0
                ? stock.map((r) => r.LocationName).filter(Boolean).join(', ')
                : item.LocationName,
          },
          this.state.locationList
        );
        this.setState({
          editLocationStock: stock,
          editLocationStockLoading: false,
          editMetricUIDRows: merged,
          editMetricUIDRowsOriginal: JSON.parse(JSON.stringify(merged)),
          editSourceItem: {
            ...item,
            LocationName: locationDisplay || item.LocationName,
          },
        });
      })
      .catch(() => {
        this.setState({
          editLocationStock: [],
          editLocationStockLoading: false,
          editMetricUIDRows: [],
          editMetricUIDRowsOriginal: [],
        });
      });
  };

  fetchEditLocationStock = (item) => {
    this.fetchEditLocationContext(item);
  };

  handleLinkEditClick = (item) => {
    const vendorId = this.resolveVendorId(item);
    this.setState({
      showEdit: true,
      editSourceItem: item,
        editForm: {
        ItemName: item.ItemName || '',
	        Lights: item.Lights ?? 0,
        VendorId: vendorId === '' || vendorId == null ? '' : vendorId,
        Cost: item.Cost ?? '',
        Margin: item.Margin ?? '',
        TargetPrice:
          item.TargetPrice != null && item.TargetPrice !== ''
            ? item.TargetPrice
            : '',
        DynamicCost:
          item.DynamicCost === 1 || item.DynamicCost === true,
        OrignalName: item.OrignalName || '',
        MetricUID: String(item.MetricUID ?? item.metricUID ?? '').trim(),
        IsNonInventory: item.IsNonInventory === 1 || item.IsNonInventory === true,
        Active: isItemActiveValue(item.Active),
        Archived: item.Archived === 1 || item.Archived === true,
        PurchaseDate: normalizePurchaseDateForInput(item.PurchaseDate),
      },
      editSaving: false,
      editDialogErrorMessage: null,
      editLocationStock: [],
      editLocationStockLoading: true,
      editMetricUIDRows: [],
      editMetricUIDRowsOriginal: [],
    });
    this.fetchEditLocationContext(item);
  };

  normalizeBarcodeItem = (item) => {
    if (!item) return item;
    return {
      ...item,
      ItemNumber: item.ItemNumber != null ? item.ItemNumber : item.itemnumber,
      ItemName: item.ItemName != null ? item.ItemName : item.itemname,
      LocationName:
        item.LocationName != null ? item.LocationName : item.locationName,
      MetricUID: String(
        item.MetricUID ??
          item.metricUID ??
          item.MetrcUID ??
          item.MatrcUID ??
          item.MatricUID ??
          item.matricUID ??
          item['MetrcUID'] ??
          item['MatrcUID'] ??
          item['Metric UID'] ??
          ''
      ).trim(),
    };
  };

  handleLinkBarCodeClick = (item, action) => {
    const normalized = this.normalizeBarcodeItem(item);
    const locationList = this.state.locationList || [];
    this.setState({
      selectedItem: normalized,
      showBarCode: true,
      barcodeMetricUIDRows: buildBarcodeMetricRows([], normalized, locationList),
      barcodeSrc: '',
    });
    this.generateBarcode(normalized);
    this.fetchBarcodeLocationContext(normalized);
  };

  fetchBarcodeLocationContext = (item) => {
    const itemId =
      item &&
      (item.ItemId ?? item.itemId ?? item.ItemID ?? item.itemid);
    const locationList = this.state.locationList || [];
    const applyFallback = () =>
      this.setState({
        barcodeMetricUIDRows: buildBarcodeMetricRows([], item, locationList),
      });

    if (!itemId) {
      applyFallback();
      return;
    }

    const user = JSON.parse(sessionStorage.getItem('user') || '{}');
    const accessToken = user.accessToken || '';
    const headers = { Authorization: `Bearer ${accessToken}` };

    Promise.all([
      apiClient.get(`/api/get/itemlocationstock`, { params: { itemId }, headers }),
      apiClient.get(`/api/get/itemmetricuid`, { params: { itemId }, headers }),
    ])
      .then(([stockRes, metricRes]) => {
        const merged = mergeMetricUidRows(
          stockRes.data || [],
          metricRes.data || [],
          item,
          locationList
        );
        this.setState({
          barcodeMetricUIDRows: buildBarcodeMetricRows(merged, item, locationList),
        });
      })
      .catch(() => applyFallback());
  };

  useStyles = makeStyles({ 
    root: { 
      "& > *": { 
        borderBottom: "unset", 
      }, 
    }, 
    
    snackbar: { 
      bottom: "104px", 
    }, 
    table: {
      maxWidth: '100%', // Set to '100%' to make the table responsive
      },
      tableHeader: {
      backgroundColor: '#f2f2f2',
      fontWeight: 'bold',
      },
      tableRow: {
      '&:hover': {
        backgroundColor: '#e0e0e0',
      },
      },
      tableCell: {
      borderBottom: '1px solid #dddddd',
      width:"150px !important",
      },
      rowDiv: {
      width:"1000px !important",
      },
      dialogCustom:{
      width:"800px !important",
      height:"600px !important",
      },
      divRight:{
      float:"right"
      }
      ,
      divLeft:{
      float:"left"
      }
  }); 

   
    state = {
      barcodeSrc:'',
        Results: [],
        selectedItem:null,
        showBarCode:false,
        showEdit:false,
        editSourceItem:null,
        editForm:null,
        editSaving:false,
        editDialogErrorMessage: null,
        editLocationStock: [],
        editMetricUIDRows: [],
        editMetricUIDRowsOriginal: [],
        fullWidth:true,
        noOfPrint:null,
        barcodeMetricUIDRows: [],
        maxWidth:'sm',
        maxEditWidth:'md',
        headers: [
          { label: "Item Number", key: "ItemNumber" },
          { label: "Item Name", key: "ItemName" },
          { label: "Lights", key: "Lights" },
          { label: "Category", key: "CategoryName" },
          { label: "Vendor Name", key: "VendorName" },
          { label: "Location", key: "LocationName" },
          { label: "Quantity", key: "Quantity" },
          { label: "Cost", key: "Cost" },
          { label: "Margin", key: "Margin" },
          { label: "TargetPrice", key: "TargetPrice" },
          { label: "PurchaseDate", key: "PurchaseDate" },
          { label: "Active", key: "Active" },
          { label: "DynamicCost", key: "DynamicCost" },
          { label: "IsNonInventory", key: "IsNonInventory" },
          { label: "Archived", key: "Archived" },
          { label: "OrignalName", key: "OrignalName" }
        ],
        vendorList: [],
        locationList: [],
        categoryList: [],
        formData: {
            itemnumber: '',
            itemname: '',
            categoryName: '',
            vendorid: '',
            quantity: '',
            cost: '',
        },
        isSubmitting: false,
        successMessage:null,
        errorMessage:null,
        index:0,
        IsAdded:false,
        rows:[],
        edit:false,
        disable:false,
       showConfirm:false,
       rowIndex:0,
       activeFilter:'active',
       itemsPage:0,
       itemsRowsPerPage:10,
       totalItemCount:0,
       listSearchQuery: '',
       listVendorFilterId: '',
       itemsSortColumn: null,
       itemsSortDirection: 'asc',
       csvExportRows: [],
       exportCsvLoading: false,
       itemsListLoading: false,
    }

    _itemsFetchSeq = 0;
    _submitInFlight = false;

    filterItemListByActiveStatus = (items, status) => {
      return (items || []).filter((item) => {
        const isArchived = item.Archived === 1 || item.Archived === true;
        if (status === 'archived') return isArchived;
        if (isArchived) return false;
        const normalizedActive = String(item.Active == null ? 1 : item.Active).toLowerCase();
        const isActive = normalizedActive === '1' || normalizedActive === 'true';
        const quantity = Number(item.Quantity ?? 0);
        if (status === 'inactive') {
          return !isActive && quantity <= 0;
        }
        return isActive;
      });
    };

    /** Client-side fallback when paged API fails; mirrors /api/get/item/paged search fields. */
    itemMatchesGridSearch = (row, qRaw) => {
      const q = (qRaw || '').toLowerCase().trim();
      if (!q) return true;
      const haystack = [
        row.ItemNumber,
        row.ItemName,
        row.CategoryName,
        row.VendorName,
        row.LocationName,
        row.MetricUID,
        row.OrignalName,
        row.PurchaseDate,
      ]
        .filter((v) => v !== undefined && v !== null)
        .map((v) => String(v).toLowerCase())
        .join(' ');
      return haystack.includes(q);
    };

    itemMatchesGridVendorFilter = (row, vendorIdRaw) => {
      const vendorId = vendorIdRaw === '' || vendorIdRaw == null ? null : Number(vendorIdRaw);
      if (!vendorId || Number.isNaN(vendorId)) return true;
      const rowVendorId = row.VendorId != null ? Number(row.VendorId) : null;
      return rowVendorId != null && !Number.isNaN(rowVendorId) && rowVendorId === vendorId;
    };

    formatRowsForCsv = (rawRows) => {
      return (rawRows || []).map((row) => ({
        ...row,
        Quantity: formatQuantityDisplay(row.Quantity),
        IsNonInventory: row.IsNonInventory === 1 || row.IsNonInventory === true ? 'Yes' : 'No',
        Archived: row.Archived === 1 || row.Archived === true ? 'Yes' : 'No',
      }));
    };

    handleExportFullListToCsv = () => {
      let user = JSON.parse(sessionStorage.getItem('user'));
      let accessToken = user && user.accessToken ? user.accessToken : '';
      const authHeaders = { headers: { Authorization: `Bearer ${accessToken}` } };
      const { totalItemCount, activeFilter, itemsSortColumn, itemsSortDirection } = this.state;
      const pageSize = Math.max(parseInt(totalItemCount, 10) || 0, 1);

      this.setState({ exportCsvLoading: true, errorMessage: null });

      const listQ = (this.state.listSearchQuery || '').trim();
      const listVendorId = this.state.listVendorFilterId;
      const pagedParams = { page: 0, pageSize, status: activeFilter };
      if (listQ) {
        pagedParams.search = listQ;
      }
      if (listVendorId !== '' && listVendorId != null) {
        pagedParams.vendorId = listVendorId;
      }
      if (itemsSortColumn) {
        pagedParams.sortBy = itemsSortColumn;
        pagedParams.sortDir = itemsSortDirection || 'asc';
      }

      apiClient
        .get(`/api/get/item/paged`, { params: pagedParams, ...authHeaders })
        .then((res) => {
          const items = res.data && res.data.items ? res.data.items : [];
          const total = res.data && typeof res.data.totalCount === 'number' ? res.data.totalCount : items.length;
          if (!items.length && total === 0) {
            this.setState({
              exportCsvLoading: false,
              errorMessage: 'No items to export for the current filter.',
            });
            setTimeout(() => this.setState({ errorMessage: null }), 4000);
            return;
          }
          const csvExportRows = this.formatRowsForCsv(items);
          this.setState({ csvExportRows, exportCsvLoading: false }, () => {
            setTimeout(() => {
              const inst = this.csvExportLinkRef.current;
              if (inst && inst.link && typeof inst.link.click === 'function') {
                inst.link.click();
              }
              setTimeout(() => this.setState({ csvExportRows: [] }), 400);
            }, 50);
          });
        })
        .catch(() => {
          apiClient
            .get(`/api/get/item`, authHeaders)
            .then((fallbackRes) => {
              const allItems = fallbackRes.data || [];
              let filtered = this.filterItemListByActiveStatus(allItems, activeFilter);
              if (listQ) {
                filtered = filtered.filter((row) => this.itemMatchesGridSearch(row, listQ));
              }
              if (listVendorId !== '' && listVendorId != null) {
                filtered = filtered.filter((row) =>
                  this.itemMatchesGridVendorFilter(row, listVendorId)
                );
              }
              if (!filtered.length) {
                this.setState({
                  exportCsvLoading: false,
                  errorMessage: 'No items to export for the current filter.',
                });
                setTimeout(() => this.setState({ errorMessage: null }), 4000);
                return;
              }
              const csvExportRows = this.formatRowsForCsv(filtered);
              this.setState({ csvExportRows, exportCsvLoading: false }, () => {
                setTimeout(() => {
                  const inst = this.csvExportLinkRef.current;
                  if (inst && inst.link && typeof inst.link.click === 'function') {
                    inst.link.click();
                  }
                  setTimeout(() => this.setState({ csvExportRows: [] }), 400);
                }, 50);
              });
            })
            .catch(() => {
              this.setState({
                exportCsvLoading: false,
                errorMessage: 'Could not load items for export.',
              });
              setTimeout(() => this.setState({ errorMessage: null }), 5000);
            });
        });
    };

    resolveVendorId = (item) => {
      if (item.VendorId != null && item.VendorId !== '') return Number(item.VendorId);
      const match = this.state.vendorList.find((v) => v.VendorName === item.VendorName);
      return match ? match.VendorId : '';
    };

    editDialogHasDirty = () => {
      const src = this.state.editSourceItem;
      const f = this.state.editForm;
      if (!f || !src) return false;
      const baseNI = src.IsNonInventory === 1 || src.IsNonInventory === true;
      const baseDyn = src.DynamicCost === 1 || src.DynamicCost === true;
      const baseActive = isItemActiveValue(src.Active);
      const costNum = (x) => {
        const n = parseFloat(x);
        return Number.isNaN(n) ? 0 : n;
      };
      const serializeMetricRows = (rows) =>
        JSON.stringify(
          (rows || []).map((r) => [
            r.locationId != null ? String(r.locationId) : '',
            String(r.metricUID ?? '').trim(),
          ])
        );
      const metricDirty =
        serializeMetricRows(this.state.editMetricUIDRows) !==
          serializeMetricRows(this.state.editMetricUIDRowsOriginal) ||
        String(f.MetricUID || '').trim() !==
          String(src.MetricUID ?? src.metricUID ?? '').trim();
      return (
        String(f.ItemName || '').trim() !== String(src.ItemName || '').trim() ||
	        costNum(f.Lights) !== costNum(src.Lights) ||
        costNum(f.Cost) !== costNum(src.Cost) ||
        costNum(f.Margin) !== costNum(src.Margin) ||
        costNum(f.TargetPrice) !== costNum(src.TargetPrice) ||
        !!f.DynamicCost !== baseDyn ||
        String(f.OrignalName || '') !== String(src.OrignalName || '') ||
        !!f.IsNonInventory !== baseNI ||
        !!f.Active !== baseActive ||
        normalizePurchaseDateForInput(f.PurchaseDate) !==
          normalizePurchaseDateForInput(src.PurchaseDate) ||
        metricDirty
      );
    };

    handleEditMetricUIDChange = (rowIndex, value) => {
      this.setState((prev) => {
        const src = prev.editSourceItem;
        const vals = prev.editForm;
        const detailRows = buildEditLocationDetailRows(
          prev.editMetricUIDRows,
          prev.editLocationStock,
          src,
          prev.locationList,
          vals?.MetricUID ?? src?.MetricUID
        );
        let rows =
          prev.editMetricUIDRows && prev.editMetricUIDRows.length
            ? prev.editMetricUIDRows.map((r) => ({ ...r }))
            : detailRows.map((r) => ({
                locationId: r.locationId,
                locationName: r.locationName,
                metricUID: r.metricUID || '',
                quantity: r.quantity,
              }));
        if (rowIndex >= 0 && rowIndex < rows.length) {
          rows[rowIndex] = { ...rows[rowIndex], metricUID: value };
        }
        return { editMetricUIDRows: rows, editDialogErrorMessage: null };
      });
    };

    buildEditMetricUidRowsForSave = () => {
      const rows = this.state.editMetricUIDRows || [];
      const locationList = this.state.locationList || [];
      return rows
        .map((r) => {
          let locationId = r.locationId != null && r.locationId !== '' ? Number(r.locationId) : null;
          if ((!locationId || Number.isNaN(locationId)) && r.locationName) {
            locationId = resolveLocIdFromName(r.locationName, locationList);
          }
          return {
            locationId: locationId && !Number.isNaN(Number(locationId)) ? Number(locationId) : null,
            metricUID: String(r.metricUID ?? '').trim(),
          };
        })
        .filter((r) => r.locationId && !Number.isNaN(r.locationId));
    };

    handleEditFormField = (field, value) => {
      this.setState((prev) => ({
        editForm: prev.editForm ? { ...prev.editForm, [field]: value } : null,
        editDialogErrorMessage: null,
      }));
    };

    handleEditDialogReset = () => {
      const src = this.state.editSourceItem;
      if (!src) return;
      const vendorId = this.resolveVendorId(src);
      this.setState({
        editForm: {
          ItemName: src.ItemName || '',
	          Lights: src.Lights ?? 0,
          VendorId: vendorId === '' || vendorId == null ? '' : vendorId,
          Cost: src.Cost ?? '',
          Margin: src.Margin ?? '',
          TargetPrice:
            src.TargetPrice != null && src.TargetPrice !== ''
              ? src.TargetPrice
              : '',
          DynamicCost:
            src.DynamicCost === 1 || src.DynamicCost === true,
          OrignalName: src.OrignalName || '',
          MetricUID: String(src.MetricUID ?? src.metricUID ?? '').trim(),
          IsNonInventory: src.IsNonInventory === 1 || src.IsNonInventory === true,
          Active: isItemActiveValue(src.Active),
          Archived: src.Archived === 1 || src.Archived === true,
          PurchaseDate: normalizePurchaseDateForInput(src.PurchaseDate),
        },
        editMetricUIDRows: JSON.parse(
          JSON.stringify(this.state.editMetricUIDRowsOriginal || [])
        ),
        editDialogErrorMessage: null,
      });
    };

    handleEditDialogSave = () => {
      const src = this.state.editSourceItem;
      const f = this.state.editForm;
      if (!f || !src) return;
      const vendorId = Number(this.resolveVendorId(src));
      const marginRaw = parseFloat(f.Margin);
      const margin = Number.isNaN(marginRaw) ? 0 : marginRaw;
      const dynamicCost = !!f.DynamicCost;
      const targetPriceRaw = parseFloat(f.TargetPrice);
	      const lightsRaw = f.Lights === '' || f.Lights == null ? 0 : Number(f.Lights);
	      if (!Number.isFinite(lightsRaw) || lightsRaw < 0) {
	        this.setState({ editDialogErrorMessage: 'Enter a valid Lights value (≥ 0).' });
	        setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
	        return;
	      }
      let cost;
      if (dynamicCost) {
        if (f.TargetPrice === '' || f.TargetPrice == null) {
          this.setState({
            editDialogErrorMessage:
              'Target price is required when Dynamic Cost is checked.',
          });
          setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
          return;
        }
        if (Number.isNaN(targetPriceRaw) || targetPriceRaw < 0) {
          this.setState({ editDialogErrorMessage: 'Enter a valid target price.' });
          setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
          return;
        }
        if (Number.isNaN(margin) || margin < 0) {
          this.setState({ editDialogErrorMessage: 'Enter a valid margin (≥ 0).' });
          setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
          return;
        }
        cost = targetPriceRaw - margin;
        if (Number.isNaN(cost) || cost < 0) {
          this.setState({
            editDialogErrorMessage:
              'Target price must be greater than or equal to margin.',
          });
          setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
          return;
        }
      } else {
        const costRaw = parseFloat(f.Cost);
        cost = Number.isNaN(costRaw) ? 0 : costRaw;
        if (cost < 0) {
          this.setState({ editDialogErrorMessage: 'Enter a valid cost.' });
          setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
          return;
        }
      }
      if (!String(f.ItemName || '').trim()) {
        this.setState({ editDialogErrorMessage: 'Item name is required.' });
        setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
        return;
      }
      if (!vendorId || Number.isNaN(vendorId)) {
        this.setState({ editDialogErrorMessage: 'This item has no vendor on file and cannot be saved.' });
        setTimeout(() => this.setState({ editDialogErrorMessage: null }), 4000);
        return;
      }
      const purchaseDateNorm = normalizePurchaseDateForInput(f.PurchaseDate);
      const nextActive = !!f.Active;
      const user = JSON.parse(sessionStorage.getItem('user'));
      const accessToken = user.accessToken;
      const resolvedItemId = src.ItemId != null ? src.ItemId : src.itemId;
      const savePayload = {
            itemId: resolvedItemId,
            itemName: String(f.ItemName).trim(),
	            lights: lightsRaw,
            vendorId,
            cost,
            margin,
            targetPrice: dynamicCost
              ? targetPriceRaw
              : Number.isNaN(targetPriceRaw)
                ? ''
                : targetPriceRaw,
            dynamicCost: dynamicCost ? 1 : 0,
            orignalName: f.OrignalName || '',
            metricUID: String(f.MetricUID || '').trim(),
            metricUIDRows: this.buildEditMetricUidRowsForSave(),
            isNonInventory: f.IsNonInventory ? 1 : 0,
            active: nextActive ? 1 : 0,
            archived: src.Archived === 1 || src.Archived === true ? 1 : 0,
            purchaseDate: purchaseDateNorm,
          };
      this.setState({ editSaving: true });
      apiClient
        .post(
          `/api/post/itemCardUpdate`,
          savePayload,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then(() => {
          this.setShowEdit(false);
          this.setState({ successMessage: 'Item saved.', editSaving: false });
          setTimeout(() => this.setState({ successMessage: null }), 3000);
          this.fetchItems(this.state.itemsPage, this.state.itemsRowsPerPage, this.state.activeFilter);
        })
        .catch((err) => {
          const apiErr = err.response && err.response.data && err.response.data.error;
          const msg =
            typeof apiErr === 'string' && apiErr.trim() !== ''
              ? apiErr
              : 'Could not save changes.';
          this.setState({
            editSaving: false,
            editDialogErrorMessage: msg,
          });
          setTimeout(() => this.setState({ editDialogErrorMessage: null }), 5000);
        });
    };

     escapeHtmlForBarcode = (s) =>
      String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    getBarcodeLabelRowsForPrint = () => {
      const rows = this.state.barcodeMetricUIDRows || [];
      if (rows.length) return rows;
      const item = this.state.selectedItem;
      if (!item) return [];
      const { locationName, metricUID } = this.getBarcodeLabelLines(item);
      return [
        {
          locationName,
          metricUID,
          printCount: Math.max(
            0,
            parseInt(this.state.noOfPrint, 10) ||
              defaultBarcodePrintCount(null, item.Quantity)
          ),
        },
      ];
    };

    buildBarcodeLabelsHtml = () => {
      const item = this.state.selectedItem;
      const barcodeSrc = this.state.barcodeSrc;
      if (!item || !barcodeSrc) return '';

      const { title } = this.getBarcodeLabelLines(item);
      const safeTitle = this.escapeHtmlForBarcode(title);
      const labels = [];
      this.getBarcodeLabelRowsForPrint().forEach((row) => {
        const count = Math.max(0, parseInt(row.printCount, 10) || 0);
        const safeLocation = this.escapeHtmlForBarcode(row.locationName || '');
        const safeMetric = this.escapeHtmlForBarcode(row.metricUID || '');
        for (let i = 0; i < count; i += 1) {
          labels.push(`
      <div class="label">
        ${safeLocation ? `<div class="label-location">${safeLocation}</div>` : ''}
        <img class="label-barcode" src="${barcodeSrc}" alt="${safeTitle}" />
        ${
          safeTitle
            ? `<div class="label-title">${safeTitle}</div>`
            : ''
        }
        ${safeMetric ? `<div class="label-metric">${safeMetric}</div>` : ''}
      </div>`);
        }
      });

      const sheets = [];
      for (let i = 0; i < labels.length; i += BARCODE_LABELS_PER_SHEET) {
        sheets.push(
          `<section class="label-sheet">${labels
            .slice(i, i + BARCODE_LABELS_PER_SHEET)
            .join('')}</section>`
        );
      }
      return sheets.join('');
    };

     handlePrintBarcode = () => {
      const barcodeHtml = this.buildBarcodeLabelsHtml();
      if (!barcodeHtml) return;
      const printWindow = window.open('', '_blank');
      if (!printWindow) return;

printWindow.document.write(`
  <html>
    <head>
      <title>Print Labels</title>
      <style>
        @page {
          size: 8.5in 11in;
          margin: 0;
        }
        * {
          box-sizing: border-box;
        }
        html,
        body {
          width: 8.5in;
          margin: 0;
          padding: 0;
          background: #fff;
        }
        .label-sheet {
          width: 8.5in;
          height: 11in;
          padding: 0.5in 0.1875in;
          display: grid;
          grid-template-columns: repeat(3, 2.625in);
          grid-template-rows: repeat(10, 1in);
          column-gap: 0.125in;
          row-gap: 0;
          overflow: hidden;
          break-after: page;
          page-break-after: always;
        }
        .label-sheet:last-child {
          break-after: auto;
          page-break-after: auto;
        }
        .label {
          width: 2.625in;
          height: 1in;
          padding: 0.035in 0.075in;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-family: Arial, Helvetica, sans-serif;
          color: #000;
          break-inside: avoid;
          page-break-inside: avoid;
        }
        .label-location,
        .label-metric {
          width: 100%;
          min-height: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 7.5pt;
          line-height: 1.05;
        }
        .label-barcode {
          display: block;
          width: auto;
          height: auto;
          max-width: 2.4in;
          max-height: 0.42in;
          object-fit: contain;
          image-rendering: -webkit-optimize-contrast;
          image-rendering: crisp-edges;
        }
        .label-title {
          width: 100%;
          max-height: 0.2in;
          overflow: hidden;
          font-size: 8pt;
          font-weight: 600;
          line-height: 1.05;
          overflow-wrap: anywhere;
        }
        @media screen {
          body {
            background: #eee;
          }
          .label-sheet {
            margin: 0 auto 0.25in;
            background: #fff;
          }
        }
      </style>
    </head>
    <body onload="window.print(); window.close();">
      ${barcodeHtml}
    </body>
  </html>
`);
printWindow.document.close();
printWindow.focus();
    };
  

    componentDidMount() {
     
     
let ItemTabIndex = JSON.parse(sessionStorage.getItem('ItemTabIndex'));
if(ItemTabIndex == '1')
{
   this.setState({
    index: 1,
   });

}

      sessionStorage.setItem('TranSearch', null);
        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = getAccessToken();
  
        apiClient.get(`/api/get/vendor`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const vendorList = res.data;
            this.setState({ vendorList });
          });

          apiClient.get(`/api/get/category`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const categoryList = res.data;
            this.setState({ categoryList });
          });

          apiClient.get(`/api/get/itemlocation`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const locationList = res.data;
            this.setState({ locationList });
          });

          apiClient
            .post(`/api/post/items/deactivateZeroQtyReserve`, {}, {
              headers: { Authorization: `Bearer ${accessToken}` },
            })
            .catch(() => {
              publishNotification('Unable to refresh inactive item status.', 'error');
            });

          this.fetchItems(0, this.state.itemsRowsPerPage, this.state.activeFilter);
  
          
         if(user.permissions.filter(x=>x.PermissionName == 'Inventory' && x.PermissionAllowed == 1).length == 0)
         {
            const { history } = this.props;
            history.push('/home');
         }
      }

      fetchItems = (
        page = 0,
        pageSize = this.state.itemsRowsPerPage,
        status = this.state.activeFilter,
        searchText
      ) => {
        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = user ? user.accessToken : '';
        const authHeaders = { headers: {"Authorization" : `Bearer ${accessToken}`} };
        const q =
          searchText !== undefined && searchText !== null
            ? String(searchText).trim()
            : (this.state.listSearchQuery || '').trim();
        const vendorId = this.state.listVendorFilterId;

        this._itemsFetchSeq += 1;
        const fetchSeq = this._itemsFetchSeq;

        this.setState({ itemsListLoading: true, activeFilter: status });

        const finishItemsFetch = () => {
          if (fetchSeq === this._itemsFetchSeq) {
            this.setState({ itemsListLoading: false });
          }
        };

        const applyItemsPage = (Results, totalItemCount) => {
          if (fetchSeq !== this._itemsFetchSeq) return;
          this.setState({
            Results,
            totalItemCount,
            itemsPage: page,
            itemsRowsPerPage: pageSize,
            activeFilter: status,
          });
        };

        const pagedParams = { page, pageSize, status };
        if (q) {
          pagedParams.search = q;
        }
        if (vendorId !== '' && vendorId != null) {
          pagedParams.vendorId = vendorId;
        }
        if (this.state.itemsSortColumn) {
          pagedParams.sortBy = this.state.itemsSortColumn;
          pagedParams.sortDir = this.state.itemsSortDirection;
        }

        apiClient.get(`/api/get/item/paged`, {
          params: pagedParams,
          ...authHeaders
        }).then(res => {
          const Results = res.data && res.data.items ? res.data.items : [];
          const totalItemCount = res.data && res.data.totalCount ? res.data.totalCount : 0;
          applyItemsPage(Results, totalItemCount);
        }).catch(() => {
          // Fallback to legacy endpoint to avoid blank screen if paged API fails.
          apiClient.get(`/api/get/item`, authHeaders).then(fallbackRes => {
            const allItems = fallbackRes.data || [];
            let filteredItems = this.filterItemListByActiveStatus(allItems, status);
            if (q) {
              filteredItems = filteredItems.filter((row) => this.itemMatchesGridSearch(row, q));
            }
            if (vendorId !== '' && vendorId != null) {
              filteredItems = filteredItems.filter((row) =>
                this.itemMatchesGridVendorFilter(row, vendorId)
              );
            }
            const startIndex = page * pageSize;
            const endIndex = startIndex + pageSize;
            applyItemsPage(
              filteredItems.slice(startIndex, endIndex),
              filteredItems.length
            );
          }).catch(() => {
            if (fetchSeq === this._itemsFetchSeq) {
              this.setState({
                itemsListLoading: false,
                errorMessage: 'Could not load items. Please try again.',
              });
              setTimeout(() => this.setState({ errorMessage: null }), 5000);
            }
          });
        }).finally(finishItemsFetch);
      };

      handleItemListSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ listSearchQuery: value });
        if (this._itemListSearchDebounceTimer) {
          clearTimeout(this._itemListSearchDebounceTimer);
        }
        this._itemListSearchDebounceTimer = setTimeout(() => {
          this._itemListSearchDebounceTimer = null;
          this.fetchItems(0, this.state.itemsRowsPerPage, this.state.activeFilter, value);
        }, 350);
      };

      handleItemListVendorFilterChange = (e) => {
        this.setState({ listVendorFilterId: e.target.value }, () => {
          this.fetchItems(0, this.state.itemsRowsPerPage, this.state.activeFilter);
        });
      };

      componentWillUnmount() {
        if (this._itemListSearchDebounceTimer) {
          clearTimeout(this._itemListSearchDebounceTimer);
        }
      }

      handleNo = () => { 
        this.setState({showConfirm:false}); 
      }; 

    handleChange = (event) => {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

    handleBarcodePrintCountChange = (index, value) => {
      const sanitized =
        typeof value === 'string' ? value.replace(/[^\d]/g, '') : value;
      this.setState((prev) => ({
        barcodeMetricUIDRows: (prev.barcodeMetricUIDRows || []).map((r, i) =>
          i === index
            ? { ...r, printCount: sanitized === '' ? '' : Number(sanitized) }
            : r
        ),
      }));
    };

    getBarcodeLabelLines = (item) => {
      if (!item) {
        return { title: '', locationName: '', metricUID: '' };
      }
      const normalized = this.normalizeBarcodeItem(item);
      const itemNumber =
        normalized.ItemNumber != null ? String(normalized.ItemNumber).trim() : '';
      const itemName =
        normalized.ItemName != null ? String(normalized.ItemName).trim() : '';
      const locationName =
        normalized.LocationName != null
          ? String(normalized.LocationName).trim()
          : '';
      const metricUID = String(normalized.MetricUID ?? '').trim();
      const titleParts = [itemNumber, itemName].filter(Boolean);
      return {
        title: titleParts.join(' - '),
        locationName,
        metricUID,
      };
    };

    generateBarcode = (item) => {
      let user = JSON.parse(sessionStorage.getItem('user'));
      let accessToken = user.accessToken;
      try {
        const params = {
          data:  item.ItemNumber+ '-' +item.ItemName,
          itemNumber: item.ItemNumber
          };
       this.setState({ barcodeSrc: '' });
         apiClient.get(`/api/get/barcode`, {params:params,
          responseType: 'arraybuffer'
        ,headers: {"Authorization" : `Bearer ${accessToken}`}}).then(res => {
          
          const barcodeBase64 = btoa(
            new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
          this.setState({ barcodeSrc: `data:image/png;base64,${barcodeBase64}`});
          });
  
      } catch (error) {
        console.error('Error fetching barcode:', error);
      }
    };
  

    handleSubmit = () => {
      if (this.state.isSubmitting || this._submitInFlight) {
        return;
      }

      const mandatoryErr = validateAllNewItemRows(this.state.rows);
      if (mandatoryErr) {
        this.setState({ errorMessage: mandatoryErr });
        setTimeout(() => this.setState({ errorMessage: null }), 10000);
        return;
      }

      const numericErr = validateItemNumericRows(this.state.rows);
      if (numericErr) {
        this.setState({ errorMessage: numericErr });
        publishNotification(numericErr, 'error');
        setTimeout(() => this.setState({ errorMessage: null }), 10000);
        return;
      }

      const dynamicCostErr = validateRowsDynamicCostRules(this.state.rows);
      if (dynamicCostErr) {
        this.setState({ errorMessage: dynamicCostErr });
        setTimeout(() => this.setState({ errorMessage: null }), 8000);
        return;
      }

      const lightsErr = validateRowsLightsRules(this.state.rows);
      if (lightsErr) {
        this.setState({ errorMessage: lightsErr });
        setTimeout(() => this.setState({ errorMessage: null }), 8000);
        return;
      }

      let user = JSON.parse(sessionStorage.getItem('user'));
      let accessToken = user.accessToken;

      const { location } = this.props;
      const pathname = location.pathname;
      const pageName = pathname.substring(1);

      const rowsForSubmit = this.state.rows.map((row) => ({
        ...row,
        vendorid: row.vendorid != null && row.vendorid !== '' ? row.vendorid : null,
      }));

      this._submitInFlight = true;
      this.setState({ isSubmitting: true, errorMessage: null });

      apiClient
        .post(`/api/post/items?userId=${user.userId}`, rowsForSubmit, {
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .then((res) => {
          const result = res.data;
          this.setState({ result });
          if (result && result.ok) {
            const hasPartialFailure =
              result.partial === true || Number(result.failedCount) > 0;
            const successMsg = hasPartialFailure
              ? 'Some items were saved.'
              : (result && result.message) || 'Successfully saved!';
            const warningMsg = hasPartialFailure
              ? (result && result.message) ||
                'There are currently no item numbers available within this category. Pls review limits for this Item Category. All other items were saved.'
              : null;
            // Keep disabled after success to prevent duplicate posts before redirect/refresh
            this.setState({
              successMessage: successMsg,
              errorMessage: warningMsg,
              isSubmitting: true,
            });

            setTimeout(() => {
              this.setState({ successMessage: null, errorMessage: null });
              if (pageName == 'item-form') {
                const { history } = this.props;
                history.push('/vendor-details');
                setTimeout(() => {
                  history.push('/item-form');
                }, 1);
              } else {
                this._submitInFlight = false;
                this.setState({ isSubmitting: false });
                this.handleChildClick();
              }
            }, 3000);
          } else {
            this._submitInFlight = false;
            const msg = (result && result.error) || 'Save failed.';
            this.setState({ errorMessage: msg, isSubmitting: false });
            setTimeout(() => this.setState({ errorMessage: null }), 8000);
          }
        })
        .catch((err) => {
          this._submitInFlight = false;
          const apiErr = err.response && err.response.data && err.response.data.error;
          const msg =
            typeof apiErr === 'string' && apiErr.trim() !== ''
              ? apiErr
              : err.message || 'Save failed. Check network or server logs.';
          this.setState({ errorMessage: msg, isSubmitting: false });
          setTimeout(() => this.setState({ errorMessage: null }), 8000);
        });
    }


    handleRemoveClick = (i) => { 
      const list = [...this.state.rows]; 
      this.setState({rows:null});
      let listNew = list.filter(x=>x.id !== (this.state.rowIndex)); 
      this.setState({rows:listNew}); 
      this.setState({showConfirm:false}); 
      
      
      this.setState({addItem:false});
    }; 

    handleConfirm = (index) => { 
      this.setState({showConfirm:true}); 
      this.setState({rowIndex:index});
    }; 

    handleCategoryChange = (e, index) => { 
      const list = [...this.state.rows]; 
      list[index]['categoryId'] = e.target.value;
      this.setState({rows:list}); 
			
    };

    handleInputChange = (e, index,type='') => { 
      this.setState({disable:false}); 
      
      
      if(type == 'Quantity')
      {
        const { name, value } = e.target; 
        // Regular expression to allow numbers with up to two decimal places
        const decimalRegex = /^\d*\.?\d{0,2}$/;
    
        if (decimalRegex.test(value)) {
         
          const list = [...this.state.rows]; 
            list[index][name] = value;
            this.setState({rows:list}); 
        }
      }else{
        const { name, value, type, checked } = e.target; 
        const inputValue = type === 'checkbox' ? checked : value;
        const list = [...this.state.rows]; 
        list[index][name] = inputValue;
        if (name === 'dynamicCost' && inputValue === true) {
          list[index].cost = '';
        }
        this.setState({rows:list}); 
  
      }
  
      
      
  
      
    
     
          
      
    }; 

    handleActiveFilterChange = (e) => {
      const nextStatus = e.target.value;
      this.fetchItems(0, this.state.itemsRowsPerPage, nextStatus);
    };

    handleItemsPageChange = (event, newPage) => {
      this.fetchItems(newPage, this.state.itemsRowsPerPage, this.state.activeFilter);
    };

    handleItemsRowsPerPageChange = (event) => {
      const nextPageSize = parseInt(event.target.value, 10);
      this.fetchItems(0, nextPageSize, this.state.activeFilter);
    };

    handleItemsSortClick = (columnId) => {
      this.setState(
        (prev) => {
          const same = prev.itemsSortColumn === columnId;
          return {
            itemsSortColumn: columnId,
            itemsSortDirection: same && prev.itemsSortDirection === 'asc' ? 'desc' : 'asc',
          };
        },
        () => {
          this.fetchItems(0, this.state.itemsRowsPerPage, this.state.activeFilter);
        }
      );
    };

    setBarCode = (action) => {
      
      this.setState({ showBarCode: action });
     
    };

    handleAdd = () => {
      this.setState({
        IsAdded: true,
        edit: true,
        rows: [...this.state.rows, createEmptyItemRow(this.state.rows)],
      });
    }; 

    handleChildClick = () => {
      this.props.onSendValue();
      };

      a11yProps(index) {
        return {
          id: `scrollable-auto-tab-${index}`,
          'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
      }
      onTabClicked = (event, newValue) => {
        this.setState({ index: newValue });
    }

    renderItemEditDialog() {
      if (!this.state.showEdit || !this.state.editSourceItem || !this.state.editForm) return null;
      const row = this.state.editSourceItem;
      const vals = this.state.editForm;
      const isActive = vals ? !!vals.Active : row.Active === 1 || row.Active === true;
      const isArchived = vals.Archived === true;
      const editMetricUIDRows = this.state.editMetricUIDRows || [];
      const editLocationDetailRows = buildEditLocationDetailRows(
        editMetricUIDRows,
        this.state.editLocationStock,
        row,
        this.state.locationList,
        vals.MetricUID ?? row.MetricUID
      );
      const metricUidEditRows =
        editMetricUIDRows.length > 0 ? editMetricUIDRows : editLocationDetailRows;
      const locationStockLoading = !!this.state.editLocationStockLoading;
      const roLabel = {
        display: 'block',
        fontSize: 12,
        color: '#637381',
        marginBottom: 6,
        fontWeight: 500,
      };
      const roValue = { fontSize: 15, color: '#212B36', fontWeight: 600, letterSpacing: '-0.01em', wordBreak: 'break-word' };
      const sectionTitle = {
        fontWeight: 600,
        fontSize: '0.6875rem',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#637381',
        marginBottom: 12,
      };
      const sectionCard = {
        padding: 20,
        borderRadius: 10,
        background: '#fff',
        border: '1px solid #e5e8eb',
        boxShadow: '0 1px 2px rgba(22, 28, 36, 0.04)',
        marginBottom: 20,
      };
      return (
    <Dialog
      fullWidth={this.state.fullWidth}
      maxWidth={this.state.maxEditWidth}
      open={this.state.showEdit}
      onClose={() => this.setShowEdit(false)}
      PaperProps={{ className: 'item-form-edit-dialog-paper' }}
    >
      <DialogTitle disableTypography style={{ padding: 0, background: '#fff' }}>
        <Box style={{ padding: '20px 24px', borderBottom: '1px solid #e5e8eb' }}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <Box flex={1} pr={2}>
              <Typography variant="h6" style={{ fontWeight: 700, fontSize: '1.15rem', letterSpacing: '-0.02em', color: '#161c24' }}>
                Edit item
              </Typography>
              <Typography variant="body2" style={{ color: '#637381', marginTop: 6, lineHeight: 1.5 }}>
                <Box component="span" style={{ fontWeight: 600, color: '#212B36' }}>{row.ItemNumber || '—'}</Box>
                {row.ItemName ? ` · ${row.ItemName}` : ''}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" flexShrink={0}>
              <Chip
                size="small"
                label={isActive ? 'Active' : 'Inactive'}
                style={{
                  fontWeight: 600,
                  height: 28,
                  ...(isActive
                    ? { backgroundColor: '#ecfdf3', color: '#067647' }
                    : { backgroundColor: '#fef3f2', color: '#b42318' }),
                }}
              />
              {isArchived ? (
                <Chip
                  size="small"
                  label="Archived"
                  style={{
                    fontWeight: 600,
                    height: 28,
                    marginLeft: 8,
                    backgroundColor: '#f4f4f5',
                    color: '#3f3f46',
                  }}
                />
              ) : null}
              <IconButton aria-label="close" onClick={() => this.setShowEdit(false)} size="small" style={{ marginLeft: 4 }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent className="item-form-edit-dialog-content">
        {this.state.editDialogErrorMessage ? (
          <Box className="item-form-edit-dialog-alert" role="alert">
            {this.state.editDialogErrorMessage}
          </Box>
        ) : null}

        <Box style={sectionCard}>
          <Typography style={sectionTitle}>Inventory summary</Typography>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={3}>
              <Typography style={roLabel}>Item #</Typography>
              <Typography style={roValue}>{row.ItemNumber || '—'}</Typography>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Typography style={roLabel}>Category</Typography>
              <Typography style={roValue}>{row.CategoryName || '—'}</Typography>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Typography style={roLabel}>Quantity</Typography>
              <Typography style={roValue}>{formatQuantityDisplay(row.Quantity)}</Typography>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Typography style={roLabel}>Reserve</Typography>
              <Typography style={roValue}>{formatQuantityDisplay(row.Reserve)}</Typography>
            </Grid>
          </Grid>
        </Box>

        <Box style={sectionCard}>
          <Typography style={sectionTitle}>Item details</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Item name"
                variant="outlined"
                required
                value={vals.ItemName}
                onChange={(e) => this.handleEditFormField('ItemName', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Purchase date"
                variant="outlined"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={vals.PurchaseDate || ''}
                onChange={(e) => this.handleEditFormField('PurchaseDate', e.target.value)}
              />
            </Grid>
	            <Grid item xs={12} sm={6}>
	              <TextField
	                fullWidth
	                size="small"
	                label="Lights"
	                variant="outlined"
	                type="number"
	                value={vals.Lights}
	                onChange={(e) => this.handleEditFormField('Lights', e.target.value)}
	                inputProps={{ min: 0, step: 1 }}
	              />
	            </Grid>
          </Grid>
        </Box>

        <Box style={sectionCard}>
          <Typography style={sectionTitle}>Pricing</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                size="small"
                label="Margin"
                variant="outlined"
                type="number"
                value={vals.Margin}
                onChange={(e) => this.handleEditFormField('Margin', e.target.value)}
                inputProps={{ min: 0, step: '0.01' }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                size="small"
                label="Target price"
                variant="outlined"
                type="number"
                required={!!vals.DynamicCost}
                value={vals.TargetPrice}
                onChange={(e) => this.handleEditFormField('TargetPrice', e.target.value)}
                inputProps={{ min: 0, step: '0.01' }}
                helperText={vals.DynamicCost ? 'Required when dynamic cost is on' : ''}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                size="small"
                label="Cost"
                variant="outlined"
                type="number"
                disabled={!!vals.DynamicCost}
                value={
                  vals.DynamicCost
                    ? (() => {
                        const tp = parseFloat(vals.TargetPrice);
                        const m = parseFloat(vals.Margin);
                        if (Number.isNaN(tp) || Number.isNaN(m)) return '';
                        const c = tp - m;
                        return c >= 0 && !Number.isNaN(c) ? String(c) : '';
                      })()
                    : vals.Cost
                }
                onChange={(e) => this.handleEditFormField('Cost', e.target.value)}
                inputProps={{ min: 0, step: '0.01' }}
                helperText={
                  vals.DynamicCost ? 'Computed: target price − margin' : ''
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Divider style={{ margin: '4px 0 8px' }} />
              <FormControlLabel
                style={{ marginLeft: 0 }}
                control={
                  <Checkbox
                    checked={!!vals.DynamicCost}
                    onChange={(e) => {
                      const c = e.target.checked;
                      const src = this.state.editSourceItem;
                      this.setState((prev) => ({
                        editForm: prev.editForm
                          ? {
                              ...prev.editForm,
                              DynamicCost: c,
                              Cost: c
                                ? ''
                                : src && src.Cost != null
                                  ? src.Cost
                                  : prev.editForm.Cost,
                            }
                          : null,
                        editDialogErrorMessage: null,
                      }));
                    }}
                    color="primary"
                  />
                }
                label="Dynamic cost (cost = target price − margin)" 
              />
            </Grid>
          </Grid>
        </Box>

        <Box style={{ ...sectionCard, marginBottom: 0 }}>
          <Typography style={sectionTitle}>Identifiers &amp; status</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Original name"
                variant="outlined"
                value={vals.OrignalName}
                onChange={(e) => this.handleEditFormField('OrignalName', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" style={{ color: '#637381', marginBottom: 8 }}>
                Location &amp; available quantity
              </Typography>
              {locationStockLoading ? (
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  value="Loading…"
                  InputProps={{ readOnly: true }}
                />
              ) : metricUidEditRows.length > 0 ? (
                <TableContainer className="item-form-edit-location-stock-table">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Location</TableCell>
                        <TableCell align="right" style={{ minWidth: 110, whiteSpace: 'nowrap' }}>
                          Available qty
                        </TableCell>
                        <TableCell>MetrcUID</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {metricUidEditRows.map((locRow, locIdx) => (
                        <TableRow
                          key={`edit-loc-detail-${locRow.locationId || locRow.locationName || locIdx}`}
                        >
                          <TableCell>{locRow.locationName || '—'}</TableCell>
                          <TableCell
                            align="right"
                            style={{ minWidth: 110, fontWeight: 600, whiteSpace: 'nowrap' }}
                          >
                            {formatLocationQuantityDisplay(locRow.quantity)}
                          </TableCell>
                          <TableCell style={{ minWidth: 160 }}>
                            <TextField
                              fullWidth
                              size="small"
                              variant="outlined"
                              value={locRow.metricUID || ''}
                              onChange={(e) =>
                                this.handleEditMetricUIDChange(locIdx, e.target.value)
                              }
                              placeholder="Enter MetrcUID"
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <TextField
                  fullWidth
                  size="small"
                  label="MetrcUID"
                  variant="outlined"
                  value={vals.MetricUID || ''}
                  onChange={(e) => this.handleEditFormField('MetricUID', e.target.value)}
                  helperText="No location stock on file for this item"
                />
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                style={{ marginLeft: 0 }}
                control={
                  <Checkbox
                    checked={!!vals.Active}
                    onChange={(e) => {
                      this.handleEditFormField('Active', e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label="Active"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                style={{ marginLeft: 0 }}
                control={
                  <Checkbox
                    checked={!!vals.IsNonInventory}
                    onChange={(e) => this.handleEditFormField('IsNonInventory', e.target.checked)}
                    color="primary"
                  />
                }
                label="Non-inventory item"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                style={{ marginLeft: 0 }}
                control={
                  <Checkbox
                    checked={!!vals.Archived}
                    disabled
                    color="primary"
                  />
                }
                label="Archived"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions
        style={{
          padding: '16px 24px',
          background: '#fff',
          borderTop: '1px solid #e5e8eb',
          justifyContent: 'space-between',
        }}
      >
        <Button onClick={this.handleEditDialogReset} disabled={!this.editDialogHasDirty() || this.state.editSaving} color="primary">
          Reset
        </Button>
        <Box>
          <Button onClick={() => this.setShowEdit(false)} style={{ marginRight: 8 }} disabled={this.state.editSaving}>
            Cancel
          </Button>
          <Button
            onClick={this.handleEditDialogSave}
            color="primary"
            variant="contained"
            disableElevation
            disabled={!this.editDialogHasDirty() || this.state.editSaving}
            style={{ minWidth: 96 }}
          >
            {this.state.editSaving ? 'Saving…' : 'Save'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
      );
    }

    render() {

      const { location } = this.props;
      const pathname = location.pathname;
      const pageName = pathname.substring(1);
    
   
        const { isSubmitting, itemsPage, itemsRowsPerPage, totalItemCount } = this.state;
        const gridResults = this.state.Results;
        return (
<div>
<Box className="Tab item-form-page">
                    <AppBar position="static">
                        <Tabs value={this.state.index} onChange={this.onTabClicked}>
                        <Tab label="Items" {...this.a11yProps(0)} />
                        <Tab label="Target Price" {...this.a11yProps(1)}/>
                        </Tabs>
                    </AppBar>
                    <Panel value={this.state.index} index={0}>
                    <div className="TargetPrice">
                    {pageName == 'item-form' &&  
                              <div>
                                <h2>Item Form</h2>
                                                <br />
                              </div> 
                            
                        }
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop:"20px" }}> 
                            <div> 
                                  <div className="alignDiv">
                                    <Button onClick={this.handleAdd}> 
                                    <AddBoxIcon onClick={this.handleAdd} /> 
                                    ADD 
                                    </Button> 
                                    </div>
                            </div> 

                            </div> 
                            <div style={{  marginTop:"10px" }}>
                                <Table  className="" 
                                    size="small"
                                    aria-label="a dense table"
                                    > 
                                        <TableHead> 
                                              <TableRow className="" > 
                                                   <TableCell className=""  align="center">Category</TableCell> 
                                                 
                                                    <TableCell className=""  align="center">Item Name</TableCell> 
                                                    <TableCell className=""  align="center">Lights</TableCell>
                                                    <TableCell className=""  align="center">Margin</TableCell> 
                                                    <TableCell className=""  align="center">Target price</TableCell> 
                                                    <TableCell className=""  align="center">Cost</TableCell> 
                                                    <TableCell className=""  align="center">Dynamic Cost</TableCell> 
                                                    <TableCell className=""  align="center">Non-inventory</TableCell> 
                                                    <TableCell className=""  align="center">Orignal Name</TableCell> 
                                                   
                                                    <TableCell className=""  align="center"></TableCell> 
                                              </TableRow> 
                                        </TableHead> 
                                        <TableBody> 
                                                        {this.state.rows.map((row, i) => {   
                                                        return ( 
                                                          
                                                                <TableRow className=""  > 
                                                                <TableCell className="" style={{ textAlign: 'left' }}   component="th" scope="row"> 
                                                                <FormControl>
                                                                  <InputLabel id="dropdown-label">Select Category</InputLabel>
                                                                            
                                                                            <Select
                                                                                    
                                                                                    name="category"
                                                                                    value={row.categoryId}
                                                                                    onChange={(e) => this.handleCategoryChange(e, i)} 
                                                                                    displayEmpty
                                                                                    inputProps={{ 'aria-label': 'Without label' }}

                                                                                >
                                                                                   {this.state.categoryList.map((item) => (
                                                                                      <MenuItem value={item.CategoryId}>  {item.CategoryName}</MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                                </FormControl>
                                                                </TableCell>

                                                                

                                                                <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                                    <input 
                                                                      type="text"
                                                                      value={row.itemname} 
                                                                      name="itemname"
                                                                      onChange={(e) => this.handleInputChange(e, i)} 
                                                                    /> 
                                                                </TableCell> 

                                                                <TableCell padding="none" style={{ textAlign: 'right' }}>
                                                                    <input
                                                                      type="number"
                                                                      name="lights"
                                                                      value={row.lights === '' || row.lights === undefined || row.lights === null ? '' : row.lights}
                                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                                      step="1"
                                                                      min="0"
                                                                      style={{ width: 76 }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell padding="none" style={{ textAlign: 'right' }}>
                                                                    <input
                                                                      type="number"
                                                                      name="margin"
                                                                      value={row.margin === '' || row.margin === undefined || row.margin === null ? '' : row.margin}
                                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                                      step="0.01"
                                                                      min="0"
                                                                      style={{ width: 88 }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell padding="none" style={{ textAlign: 'right' }}>
                                                                    <input
                                                                      type="number"
                                                                      name="targetPrice"
                                                                      value={
                                                                        row.targetPrice === '' ||
                                                                        row.targetPrice === undefined ||
                                                                        row.targetPrice === null
                                                                          ? ''
                                                                          : row.targetPrice
                                                                      }
                                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                                      step="0.01"
                                                                      min="0"
                                                                      required={!!row.dynamicCost}
                                                                      title={
                                                                        row.dynamicCost
                                                                          ? 'Required when Dynamic cost is checked'
                                                                          : ''
                                                                      }
                                                                      style={{ width: 96 }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell padding="none" style={{ textAlign: 'right' }}>
                                                                    <input
                                                                      type="number"
                                                                      name="cost"
                                                                      value={
                                                                        row.dynamicCost
                                                                          ? ''
                                                                          : row.cost === '' ||
                                                                              row.cost === undefined ||
                                                                              row.cost === null
                                                                            ? ''
                                                                            : row.cost
                                                                      }
                                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                                      step="0.01"
                                                                      min="0"
                                                                      disabled={!!row.dynamicCost}
                                                                      title={
                                                                        row.dynamicCost
                                                                          ? 'Cost is computed as target price − margin'
                                                                          : ''
                                                                      }
                                                                      style={{ width: 88 }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell padding="none" style={{ textAlign: 'center' }}>
                                                                    <input
                                                                      type="checkbox"
                                                                      checked={!!row.dynamicCost}
                                                                      name="dynamicCost"
                                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                                    />
                                                                </TableCell>

                                                                <TableCell padding="none" style={{ textAlign: 'center' }}>
                                                                    <input
                                                                      type="checkbox"
                                                                      checked={!!row.isNonInventory}
                                                                      name="isNonInventory"
                                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                                    />
                                                                </TableCell>

                                                                <TableCell padding="none" style={{ textAlign: 'left' }}>
                                                                    <input
                                                                      type="text"
                                                                      value={row.orignalName || ''}
                                                                      name="orignalName"
                                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                                    />
                                                                </TableCell>

                                                              <TableCell  className="" 
                                                                    component="th"
                                                                    scope="row"
                                                                    align="center"
                                                                    >
                                                                      <Button className="mr10" onClick={(e) =>this.handleConfirm(row.id)}> 
                                                                          <DeleteOutlineIcon /> 
                                                                        </Button> 
                                                                </TableCell> 
                                                            
                                                                      {this.state.showConfirm && ( 
                                                                          <div> 
                                                                            <Dialog 
                                                                            open={this.state.showConfirm} 
                                                                            onClose={this.handleNo} 
                                                                            aria-labelledby="alert-dialog-title"
                                                                            aria-describedby="alert-dialog-description"
                                                                            > 
                                                                            <DialogTitle id="alert-dialog-title"> 
                                                                              {"Confirm Delete"} 
                                                                            </DialogTitle> 
                                                                            <DialogContent> 
                                                                              <DialogContentText id="alert-dialog-description"> 
                                                                              Are you sure to delete
                                                                              </DialogContentText> 
                                                                            </DialogContent> 
                                                                            <DialogActions> 
                                                                              <Button 
                                                                              onClick={() => this.handleRemoveClick()}
                                                                              color="primary"
                                                                              autoFocus 
                                                                              > 
                                                                              Yes 
                                                                              </Button> 
                                                                              <Button 
                                                                              onClick={this.handleNo} 
                                                                              color="primary"
                                                                              autoFocus 
                                                                              > 
                                                                              No 
                                                                              </Button> 
                                                                            </DialogActions> 
                                                                            </Dialog> 
                                                                          </div> 
                                                                        )} 
                                                                  </TableRow> 
                                                          
                                                            ); 
                                                        })} 
                                        </TableBody> 
                                </Table> 
                                <br /><br /><br />
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={this.handleSubmit}
                                    disabled={isSubmitting}
                                    startIcon={
                                      isSubmitting && !this.state.successMessage ? (
                                        <CircularProgress size={18} color="inherit" thickness={5} />
                                      ) : null
                                    }
                                    style={{
                                      minWidth: 140,
                                      opacity: isSubmitting ? 0.85 : 1,
                                      pointerEvents: isSubmitting ? 'none' : 'auto',
                                    }}
                                >
                                    {isSubmitting
                                      ? (this.state.successMessage ? 'Submitted' : 'Submitting…')
                                      : 'Submit'}
                                </Button>

                                {this.state.successMessage && (
                          <div
                            style={{
                              backgroundColor: '#28a745',
                              color: '#fff',
                              padding: '10px',
                              marginTop: '10px',
                            }}
                          >
                            {this.state.successMessage}
                          </div>
                        )}

                {this.state.errorMessage && (
                        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px', whiteSpace: 'pre-line' }}>
                          {this.state.errorMessage}
                        </div>
                      )}
                            </div>
                            
                           
                          
                {pageName == 'item-form' && 

                <div className="item-form-grid-section" style={{ maxWidth: '100%', paddingTop: '24px' }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: '3px' }}>
                <div>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      value={this.state.activeFilter}
                      onChange={this.handleActiveFilterChange}
                    >
                      <FormControlLabel value="active" control={<Radio color="primary" />} label="Active" />
                      <FormControlLabel value="inactive" control={<Radio color="primary" />} label="Inactive" />
                      <FormControlLabel value="archived" control={<Radio color="primary" />} label="Archived" />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div>
                <CSVLink
                  ref={this.csvExportLinkRef}
                  data={this.state.csvExportRows}
                  headers={this.state.headers}
                  filename={`inventory-items-${this.state.activeFilter}.csv`}
                  style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden', pointerEvents: 'none', opacity: 0 }}
                  target="_blank"
                >
                  Export
                </CSVLink>
                <Button
                  color="primary"
                  size="small"
                  variant="outlined"
                  disabled={this.state.exportCsvLoading}
                  onClick={this.handleExportFullListToCsv}
                >
                  {this.state.exportCsvLoading ? 'Preparing export…' : 'Export to Excel'}
                </Button>
                </div>
                </div>
                <div>
                    <div className="item-form-grid-toolbar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                      <Typography variant="h6" component="h3" style={{ marginBottom: 0, fontWeight: 600 }}>
                        Item Details
                      </Typography>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginLeft: 'auto' }}>
                        <FormControl size="small" variant="outlined" style={{ minWidth: 200 }}>
                          <InputLabel id="item-list-vendor-filter-label" shrink>
                            Vendor
                          </InputLabel>
                          <Select
                            labelId="item-list-vendor-filter-label"
                            label="Vendor"
                            value={this.state.listVendorFilterId}
                            onChange={this.handleItemListVendorFilterChange}
                            displayEmpty
                            renderValue={(selected) => {
                              if (selected === '' || selected == null) {
                                return 'All vendors';
                              }
                              const vendor = (this.state.vendorList || []).find(
                                (v) => String(v.VendorId) === String(selected)
                              );
                              return vendor ? vendor.VendorName : '';
                            }}
                          >
                            <MenuItem value="">
                              <em>All vendors</em>
                            </MenuItem>
                            {(this.state.vendorList || []).map((v) => (
                              <MenuItem key={v.VendorId} value={String(v.VendorId)}>
                                {v.VendorName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <TextField
                        className="item-form-list-search"
                        value={this.state.listSearchQuery}
                        onChange={this.handleItemListSearchChange}
                        size="small"
                        variant="outlined"
                        placeholder="Search all items (database)…"
                        inputProps={{ 'aria-label': 'Search items' }}
                        style={{ width: 320 }}
                      />
                      </div>
                    </div>
                    <div className="item-form-grid-loading-wrap">
                      {this.state.itemsListLoading && (
                        <div
                          className="item-form-grid-loading-overlay"
                          role="status"
                          aria-live="polite"
                          aria-busy="true"
                        >
                          <div className="item-form-grid-loading-box">
                            <div className="item-form-grid-spinner" aria-hidden="true" />
                            <span>Loading items…</span>
                          </div>
                        </div>
                      )}
                    <TableContainer className="item-form-grid-container">
                      <Table
                        stickyHeader
                        aria-label="item details table"
                        className="item-form-grid-table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell>
                              <TableSortLabel
                                active={this.state.itemsSortColumn === 'ItemNumber'}
                                direction={this.state.itemsSortColumn === 'ItemNumber' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('ItemNumber')}
                              >
                                Item #
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.itemsSortColumn === 'ItemName'}
                                direction={this.state.itemsSortColumn === 'ItemName' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('ItemName')}
                              >
                                Item Name
                              </TableSortLabel>
                            </TableCell>
	                            <TableCell align="right">
	                              <TableSortLabel
	                                style={{ flexDirection: 'row-reverse' }}
	                                active={this.state.itemsSortColumn === 'Lights'}
	                                direction={this.state.itemsSortColumn === 'Lights' ? this.state.itemsSortDirection : 'asc'}
	                                onClick={() => this.handleItemsSortClick('Lights')}
	                              >
	                                Lights
	                              </TableSortLabel>
	                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.itemsSortColumn === 'CategoryName'}
                                direction={this.state.itemsSortColumn === 'CategoryName' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('CategoryName')}
                              >
                                Category
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.itemsSortColumn === 'VendorName'}
                                direction={this.state.itemsSortColumn === 'VendorName' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('VendorName')}
                              >
                                Vendor
                              </TableSortLabel>
                            </TableCell>
                            <TableCell align="right">
                              <TableSortLabel
                                style={{ flexDirection: 'row-reverse' }}
                                active={this.state.itemsSortColumn === 'Quantity'}
                                direction={this.state.itemsSortColumn === 'Quantity' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('Quantity')}
                              >
                                Qty
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.itemsSortColumn === 'LocationName'}
                                direction={this.state.itemsSortColumn === 'LocationName' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('LocationName')}
                              >
                                Location
                              </TableSortLabel>
                            </TableCell>
                            <TableCell align="right">
                              <TableSortLabel
                                style={{ flexDirection: 'row-reverse' }}
                                active={this.state.itemsSortColumn === 'Reserve'}
                                direction={this.state.itemsSortColumn === 'Reserve' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('Reserve')}
                              >
                                Reserve
                              </TableSortLabel>
                            </TableCell>
                            <TableCell align="right">
                              <TableSortLabel
                                style={{ flexDirection: 'row-reverse' }}
                                active={this.state.itemsSortColumn === 'TargetPrice'}
                                direction={this.state.itemsSortColumn === 'TargetPrice' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('TargetPrice')}
                              >
                                Target price
                              </TableSortLabel>
                            </TableCell>
                            <TableCell align="right">
                              <TableSortLabel
                                style={{ flexDirection: 'row-reverse' }}
                                active={this.state.itemsSortColumn === 'Cost'}
                                direction={this.state.itemsSortColumn === 'Cost' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('Cost')}
                              >
                                Cost
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.itemsSortColumn === 'OrignalName'}
                                direction={this.state.itemsSortColumn === 'OrignalName' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('OrignalName')}
                              >
                                Orig name
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.itemsSortColumn === 'PurchaseDate'}
                                direction={this.state.itemsSortColumn === 'PurchaseDate' ? this.state.itemsSortDirection : 'asc'}
                                onClick={() => this.handleItemsSortClick('PurchaseDate')}
                              >
                                Purch dt
                              </TableSortLabel>
                            </TableCell>
                            <TableCell />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {gridResults.map((row, idx) => {
                            const cellTitle = (v) =>
                              v != null && String(v).trim() !== '' ? String(v) : undefined;
                            return (
                            <TableRow key={row.ItemId != null ? String(row.ItemId) : `item-${row.ItemNumber || idx}-${idx}`}>
                              <TableCell>
                                <a
                                  className="item-form-grid-link"
                                  href="javascript:void(0)"
                                  onClick={() => this.handleLinkEditClick(row)}
                                >
                                  Edit
                                </a>
                              </TableCell>
                              <TableCell title={cellTitle(row.ItemNumber)}>{row.ItemNumber}</TableCell>
                              <TableCell title={cellTitle(row.ItemName)}>{row.ItemName}</TableCell>
	                              <TableCell align="right">{formatQuantityDisplay(row.Lights)}</TableCell>
                              <TableCell title={cellTitle(row.CategoryName)}>{row.CategoryName}</TableCell>
                              <TableCell title={cellTitle(row.VendorName)}>{row.VendorName || '—'}</TableCell>
                              <TableCell align="right">{formatQuantityDisplay(row.Quantity)}</TableCell>
                              <TableCell
                                title={cellTitle(
                                  getItemLocationDisplayName(row, this.state.locationList)
                                )}
                              >
                                {getItemLocationDisplayName(row, this.state.locationList) || '—'}
                              </TableCell>
                              <TableCell align="right">{formatQuantityDisplay(row.Reserve)}</TableCell>
                              <TableCell align="right">
                                {row.TargetPrice != null && row.TargetPrice !== ''
                                  ? Number(row.TargetPrice).toFixed(2)
                                  : '—'}
                              </TableCell>
                              <TableCell align="right">{Number(row.Cost ?? 0).toFixed(2)}</TableCell>
                              <TableCell title={cellTitle(row.OrignalName)}>{row.OrignalName}</TableCell>
                              <TableCell title={cellTitle(formatPurchaseDateDisplay(row.PurchaseDate))}>
                                {formatPurchaseDateDisplay(row.PurchaseDate)}
                              </TableCell>
                              <TableCell>
                                <a
                                  className="item-form-grid-link"
                                  href="javascript:void(0)"
                                  onClick={() => this.handleLinkBarCodeClick(row, 'edit')}
                                >
                                  Barcode
                                </a>
                              </TableCell>
                            </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </div>
                  </div>
                <TablePagination
                  component="div"
                  count={totalItemCount}
                  page={itemsPage}
                  onChangePage={this.handleItemsPageChange}
                  rowsPerPage={itemsRowsPerPage}
                  onChangeRowsPerPage={this.handleItemsRowsPerPageChange}
                  rowsPerPageOptions={[5, 10, 20, 50]}
                  disabled={this.state.itemsListLoading}
                />


                </div>

                }
                          
                        </div>
        
                    </Panel>
                    <Panel value={this.state.index} index={1}>
                      <TargetPrice />
                    </Panel>
                    </Box>

  {this.renderItemEditDialog()}

  {this.state.showBarCode && ( 
					<div> 
						<Dialog  
						  fullWidth
						  maxWidth="md"
						open={this.state.showBarCode} 
						onClose={() => this.setShowBarCode(false)} 
						>
            <DialogTitle id="alert-dialog-title"> 
						
						<div style={{float:"right"}}>
						<IconButton
								aria-label="close"
								onClick={() => this.setShowBarCode(false)}
								sx={{
									position: "fixed",
									right: 8,
									top: 5,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								<CloseIcon />
								</IconButton>
						</div>
							
							
						</DialogTitle> 
					
						<DialogContent id="alert-dialog-description"> 
							<DialogContentText component="div"> 
                <div className="row mt-5" >
                    {this.state.selectedItem && (() => {
                      const labelLineStyle = {
                        marginTop: 4,
                        fontSize: '0.875rem',
                        lineHeight: 1.35,
                        fontWeight: 500,
                        wordWrap: 'break-word',
                        WebkitFontSmoothing: 'antialiased',
                        MozOsxFontSmoothing: 'grayscale',
                      };
                      const barcodeRows = this.state.barcodeMetricUIDRows || [];
                      const multiLocation = barcodeRows.length > 1;
                      const { title: barcodeTitle } = this.getBarcodeLabelLines(
                        this.state.selectedItem
                      );
                      return (
       <div className="col-md-12">
          <h3 style={{ margin: '0 0 16px', lineHeight: 1.35, fontSize: '1.125rem', textAlign: 'center' }}>
            Barcode preview
          </h3>
          <div
            style={{
              margin: '0 auto 16px',
              maxWidth: 560,
              padding: '10px 12px',
              borderRadius: 4,
              backgroundColor: '#f5f7fa',
              color: '#52606d',
              fontSize: '0.8rem',
              lineHeight: 1.4,
              textAlign: 'center',
            }}
          >
            Letter sheet: 30 labels (3 x 10), each 2.625&quot; x 1&quot;. Print at 100%
            scale with browser headers and footers disabled.
          </div>
          {barcodeRows.length ? (
            barcodeRows.map((row, idx) => (
              <div
                key={`${row.locationId || row.locationName}-${idx}`}
                className="item-form-barcode-preview"
                style={{
                  textAlign: 'center',
                  padding: '16px 12px',
                  marginBottom: idx < barcodeRows.length - 1 ? 20 : 0,
                  border: multiLocation ? '1px solid #ccc' : 'none',
                  borderRadius: 4,
                  backgroundColor: multiLocation ? '#fafafa' : 'transparent',
                }}
              >
                {multiLocation ? (
                  <div
                    style={{
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      color: '#666',
                      marginBottom: 8,
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                    }}
                  >
                    Location {idx + 1} of {barcodeRows.length}
                  </div>
                ) : null}
                {row.locationName ? (
                  <div style={{ ...labelLineStyle, marginTop: 0, marginBottom: 8 }}>
                    {row.locationName}
                  </div>
                ) : null}
                {this.state.barcodeSrc ? (
                  <img
                    alt="Barcode"
                    src={this.state.barcodeSrc}
                    className="item-form-barcode-image"
                  />
                ) : (
                  <p>Loading barcode...</p>
                )}
                {barcodeTitle ? (
                  <div
                    className="item-form-barcode-title"
                    style={{
                      ...labelLineStyle,
                      marginTop: 8,
                      fontSize: '0.95rem',
                      fontWeight: 600,
                      color: '#212B36',
                    }}
                  >
                    {barcodeTitle}
                  </div>
                ) : null}
                {row.metricUID ? (
                  <div style={labelLineStyle}>{row.metricUID}</div>
                ) : null}
                <div
                  style={{
                    marginTop: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8,
                  }}
                >
                  <label style={{ margin: 0, fontWeight: 500 }}>Number of labels</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={row.printCount ?? ''}
                    onChange={(e) =>
                      this.handleBarcodePrintCountChange(idx, e.target.value)
                    }
                    style={{ width: 72, textAlign: 'center' }}
                  />
                </div>
              </div>
            ))
          ) : (
            <div
              className="item-form-barcode-preview"
              style={{ textAlign: 'center', padding: '10px 0' }}
            >
              <p>Loading location details...</p>
            </div>
          )}
        </div>
                      );
                    })()}

                    <div class="row mt-5"  style={{textAlign:"center"}}>
                        <div class="col-md-6 mr-1" style={{textAlign:"center",float:"left",marginRight:"2px"}}>
                            <Button className="mr10"  color="primary"
                                            variant="contained" onClick={this.handlePrintBarcode} > 
                                                                                Print
                                                                                </Button> 
                        </div>
                        <div class="col-md-6" style={{textAlign:"center",float:"left"}}>
                            <Button className="mr10"  color="primary"
                                            variant="contained" onClick={() => this.setShowBarCode(false)} > 
                                                                                Close
                                                                                </Button> 
                        </div>
                    </div>
                </div>
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							
							
						</DialogActions> 
						</Dialog> 
            
					</div> 
					)} 
</div>


       
        );
    }
}
export default withRouter(ItemForm);
